"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { transformValueToEditorSchema } from '../helpers/transformValueToEditorSchema.mjs';
import { $getSelection, HISTORY_MERGE_TAG, $setSelection } from 'lexical';
import { useEffect } from 'react';

const getRootParagraphNodes = (editorState) => {
  const paragraph = editorState.toJSON().root.children[0];
  if (paragraph.type !== "paragraph") return [];
  return paragraph.children;
};
function StateSyncPlugin({ value, schema }) {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    editor.update(() => {
      const currentState = editor.getEditorState();
      const newState = editor.parseEditorState(transformValueToEditorSchema(value, schema));
      const currentRootParagraph = JSON.stringify(getRootParagraphNodes(currentState));
      const newRootParagraph = JSON.stringify(getRootParagraphNodes(newState));
      if (currentRootParagraph !== newRootParagraph) {
        const selection = $getSelection();
        editor.setEditorState(newState, {
          tag: HISTORY_MERGE_TAG
        });
        const selectionClone = selection?.clone();
        $setSelection(selectionClone ?? null);
      }
    });
  }, [JSON.stringify(value)]);
  return null;
}

export { StateSyncPlugin };
